import { SpectrogramPoint } from '@ledium/types';

export function computeSpectralSimilarity(recipe: SpectrogramPoint[], mix: SpectrogramPoint[], unit: 'pfd' | 'irradiance'): number {
    let errorSq = 0;
    let magRecipeSq = 0;
    for (let i = 0; i < recipe.length; i++) {
        errorSq += (mix[i][unit] - recipe[i][unit]) ** 2;
        magRecipeSq += recipe[i][unit] ** 2;
    }
    if (magRecipeSq === 0) {
        return 0;
    }
    return Math.max(0, Math.round((1 - Math.sqrt(errorSq / magRecipeSq)) * 100));
}
